// extracted by mini-css-extract-plugin
export default {"root":"DeleteOptionModal_root__yCOTW","question":"DeleteOptionModal_question__4Ao1Q"};